/*俄语*/
export default {
  route:{
   "title": "Система публикации информации",
    "home": "Главная",
    "terminal": "Терминал",
    "program": "Программа",
    "h5program": "Программа",
    "my": "Мой",
    "remote_control": "Пульт дистанционного управления",
    "task_details": "Детали задачи",
    "add_task": "Добавить задачу",
    "program_list": "Список программ",
    "terminal_info": "Информация о терминале",
    "add_resolution": "Добавить разрешение",
    "add_program": "Добавить программу",
    "material_management": "Управление материалами",
    "create_program": "Новая программа",
    "login": "Войти",
    "reset_password": "Сбросить пароль",
    "change_password": "Изменить пароль",
    "preview": "Предпросмотр"
  },
  append_field:{
   "input_code": "Введите код подтверждения",
    "code_error": "Ошибка кода подтверждения",
    "fill_code": "Пожалуйста, введите код подтверждения",
    "dOut": "3D вращение наружу",
    "dIn": "3D вращение внутрь",
    "dxiao": "3D эффект рамки",
    "selectImage": "Пожалуйста, выберите изображение",
    "onlySelectOneImage": "Можно выбрать только одно изображение",
    "imageFormatError": "Ошибка формата изображения",
    "cancel": "Отмена",
    "selectedNumber": "Выбрано",
    "confirm": "Подтвердить",
    "loadinga": "Загрузка...",
    "loadingb": "Загружается",
    "uploading": "Загрузка",
    "selectStartDates": "Выберите дату начала",
    "selectEndDates": "Выберите дату окончания",
    "createTask": "Создать задачу",
    "selectPrograms": "Выберите программу",
    "createPrograms": "Создать программу",
    "editTask": "Редактировать задачу",
    "fillTaskName": "Пожалуйста, введите название",
    "selectTaskGroup": "Пожалуйста, выберите группу задач",
    "selectProgram": "Пожалуйста, выберите программу",
    "selected": "Выбрано",
    "programs": "программ",
    "selectDevice": "Пожалуйста, выберите устройство",
    "sendTaskSuccess": "Задача успешно отправлена",
    "taskName": "Название",
    "playMode": "Режим воспроизведения",
    "replaceMode": "Режим замены",
    "appendMode": "Дополнительный режим",
    "apotpatterns": "Промежуточный режим",
    "dateRange": "Дата воспроизведения",
    "timeRange": "Время воспроизведения",
    "taskPeriod": "Назначенная неделя",
    "mon": "Пн",
    "tue": "Вт",
    "wed": "Ср",
    "thu": "Чт",
    "fri": "Пт",
    "sat": "Сб",
    "sun": "Вс",
    "back": "Назад",
    "programList": "Список программ",
    "deviceList": "Список устройств",
    "enterContent": "Пожалуйста, введите содержимое",
    "taskGroup": "Группа задач",
    "selectStartDate": "Пожалуйста, выберите дату начала",
    "selectEndDate": "Пожалуйста, выберите дату окончания",
    "selectStartTime": "Пожалуйста, выберите время начала",
    "selectEndTime": "Пожалуйста, выберите время окончания",
    "addTask": "Добавить задачу",
    "topLeft": "Верхний левый угол",
    "topCenter": "Верх по центру",
    "topRight": "Верхний правый угол",
    "leftCenter": "Лево по центру",
    "center": "По центру",
    "rightCenter": "Право по центру",
    "bottomLeft": "Нижний левый угол",
    "bottomCenter": "Низ по центру",
    "bottomRight": "Нижний правый угол",
    "enterText": "Пожалуйста, введите текст",
    "fontColor": "Цвет шрифта",
    "bgColor": "Цвет фона",
    "scrollDirection": "Направление прокрутки",
    "scrollSpeed": "Скорость прокрутки",
    "fontSize": "Размер шрифта",
    "alignment": "Выравнивание",
    "subtitle": "Субтитры",
    "enterURL": "Пожалуйста, введите URL",
    "webPage": "Веб-страница",
    "enterMediaURL": "Пожалуйста, введите URL медиа",
    "media": "Потоковое мультимедиа",
    "selectVideo": "Пожалуйста, выберите видео",
    "unsupportedFormat": "Неподдерживаемый формат файла",
    "cancelAllSelections": "Пожалуйста, отмените все выбранные материалы перед загрузкой нового файла",
    "fileName": "Имя файла",
    "fileSize": "Размер файла",
    "uploadProgress": "Прогресс загрузки",
    "cancelUpload": "Отменить загрузку",
    "cancelAllUploads": "Отменить все загрузки",
    "leftToRights": "Слева направо",
    "rightToLefts": "Справа налево",
    "bottomToTops": "Снизу вверх",
    "static": "Статичный",
    "slow": "Медленно",
    "medium": "Средне",
    "fast": "Быстро",
    "colorValue": "Значение цвета",
    "defaultEffect": "Эффект по умолчанию",
    "rightToLeft": "Справа налево",
    "leftToRight": "Слева направо",
    "topToBottom": "Сверху вниз",
    "bottomToTop": "Снизу вверх",
    "accordionSqueeze": "Эффект аккордеона",
    "zoomInFade": "Увеличение с затуханием",
    "zoomOutFade": "Уменьшение с затуханием",
    "depthOfField": "Глубина резкости",
    "leftRightRotate": "Поворот влево-вправо",
    "upDownRotate": "Поворот вверх-вниз",
    "counterclockwiseRotate": "Поворот против часовой стрелки",
    "clockwiseRotate": "Поворот по часовой стрелке",
    "upDownZoom": "Масштабирование вверх-вниз",
    "scaleFade": "Масштабирование с затуханием",
    "zoomInDisappearing": "Увеличение с исчезновением",
    "transparentFade": "Прозрачное затухание",
    "gradientScale": "Градиентное масштабирование",
    "deleteMaterial": "Удалить материал",
    "confirmDeleteMaterial": "Подтвердить удаление материала?",
    "unreviewed": "Не проверено",
    "normal2": "Нормально",
    "violating": "Нарушение",
    "suspectedViolating": "Подозревается нарушение",
    "delete": "Удалить",
    "selectMaterial": "Пожалуйста, выберите материал",
    "deleteProgramGroup": "Удалить группу программ",
    "confirmDeleteGroup": "Подтвердить удаление группы?",
    "add": "Добавить",
    "toggle_effect": "Переключить эффект",
    "toggle_time": "Переключить время",
    "pub_toggle_time": "Время переключения",
    "fullscreen": "Полноэкранный",
    "normal": "Обычный",
    "interactive": "Интерактивный",
    "main_screen": "Основной экран",
    "sub_screen": "Дополнительный экран",
    "dual_screen": "Двойной экран",
    "sync_task": "Синхронизировать задачу",
    "normal_mode": "Обычный режим",
    "basic_info": "Основная информация",
    "program_info": "Детали задачи",
    "task_name": "Название задачи",
    "task_type": "Тип задачи",
    "pub_task": "Обычная задача",
    "hu_task": "Интерактивная задача",
    "no_data": "Нет данных",
    "no_msg": "Нет информации",
    "program_name": "Название программы",
    "program_resolution": "Разрешение программы",
    "program_type": "Тип программы",
    "screen_category": "Категория экрана",
    "edit_program": "Редактировать программу",
    "edit": "Редактировать",
    "send": "Отправить",
    "create": "Создать группу",
    "reload": "Обновить",
    "name": "Имя",
    "create_task_z": "Создать группу задач",
    "ps_push_name": "Пожалуйста, введите имя группы",
    "device_list": "Список устройств",
    "delete_task_group": "Удалить группу задач",
    "confirm_delete_group": "Вы уверены, что хотите удалить эту группу?",
    "delete_success": "Удаление успешно",
    "name_cannot_be_empty": "Имя не может быть пустым",
    "character_length_limit": "Длина имени должна быть не более 10 символов",
    "create_task_success": "Задача успешно создана",
    "create_task_failed": "Не удалось создать задачу",
    "confirm_delete_task": "Вы уверены, что хотите удалить задачу?",
    "task_details": "Детали задачи",
    "download_success": "Загрузка успешна",
    "waiting_download": "Ожидание загрузки",
    "downloading": "Загрузка",
    "confirm_delete": "Вы уверены, что хотите удалить?",
    "confirm_delete_all": "Вы уверены, что хотите удалить все?",
    "confirm_delete_selected": "Вы уверены, что хотите удалить выбранное?",
    "no_data_to_clear": "Нет данных для очистки!",
    "refresh": "Обновить",
    "clear_all": "Очистить все",
    "clear_completed": "Очистить завершенные",
    "device_id": "ID устройства",
    "task_size": "Размер задачи",
    "speed": "Скорость",
    "download_progress": "Прогресс загрузки",
    "title": "Заголовок",
    "volume": "Громкость",
    "deleteP": "Удалить программу",
    "con_P": "Вы уверены, что хотите удалить эту программу?",
    "clear": "Очистить",
    "download_status": "Статус загрузки",
    "height_width_cannot_be_empty": "Высота/Ширина не может быть пустой",
    "add_success": "Добавление успешно",
    "enter_number_between_300_to_8000": "Пожалуйста, введите число от 300 до 8000",
    "width": "Ширина",
    "enter_width": "Пожалуйста, введите ширину",
    "height": "Высота",
    "enter_height": "Пожалуйста, введите высоту",
    "confirm_leave_page": "Вы уверены, что хотите покинуть эту страницу?",
    "add_content_to_control": "Пожалуйста, добавьте содержимое к элементу управления",
    "add_control": "Пожалуйста, добавьте элемент управления",
    "save_success": "Сохранение успешно",
    "save": "Сохранить",
    "create_program": "Создать программу",
    "guess": "Угадай",
    "modify": "Изменить",
    "text": "Текст",
    "image": "Картинка",
    "background_image": "Фоновое изображение",
    "background_music": "Фоновая музыка",
    "replace": "Заменить",
    "use_this_template": "Использовать этот шаблон",
    "apply_template": "Применить шаблон",
    "enter_program_name": "Пожалуйста, введите название программы",
    "program_group": "Группа программ",
    "select_program_group": "Пожалуйста, выберите группу программ",
    "group_list": "Список групп",
    "preview": "Предварительный просмотр",
    "my_apps": "Мои приложения",
    "template_center": "Центр шаблонов",
    "home": "Главная",
    "source_of_visit": "Источник посещения",
    "online": "Онлайн",
    "terminal_status": "Статус",
    "memory_status": "Емкость хранилища",
    "login": "Войти",
    "sms_verification": "СМС верификация",
    "email_verification": "Электронная почта верификация",
    "log_in": "Войти",
    "enter_username": "Пожалуйста, введите имя пользователя",
    "username_cannot_be_empty": "Имя пользователя не может быть пустым",
    "password_cannot_be_empty": "Пароль не может быть пустым",
    "incorrect_phone_format_for_verification_code": "Неверный формат номера телефона для получения кода подтверждения, пожалуйста, свяжитесь с администратором для изменения!",
    "incorrect_email_format_for_verification_code": "Неверный формат электронной почты для получения кода подтверждения, пожалуйста, свяжитесь с администратором для изменения!",
    "incorrect_phone_or_email_format_for_verification_code": "Неверный формат номера телефона или электронной почты для получения кода подтверждения, пожалуйста, свяжитесь с администратором для изменения!",
    "reset_password": "Сбросить пароль",
    "remember_password": "Запомнить пароль",
    "register": "Зарегистрировать аккаунт",
    "current_version_4.1.6": "V4.1.8",
    "notification_about_network_security": "Уведомление о сетевой безопасности",
    "got_it": "Понял",
    "please_authenticate_for_account_safety": "Для вашей безопасности, пожалуйста, пройдите аутентификацию",
    "enter_account": "Пожалуйста, введите аккаунт",
    "enter_password": "Пожалуйста, введите пароль",
    "verification_code": "Код подтверждения",
    "none": "Нет",
    "personal_center": "Личный кабинет",
    "remote_control": "Удаленное управление",
    "refresh_success": "Обновление успешно!",
    "logout": "Выйти",
    "confirm_logout": "Вы уверены, что хотите выйти?",
    "user_status": "Статус пользователя",
    "customer_address": "Адрес клиента",
    "account_period": "Срок действия аккаунта",
    "device_control": "Управление устройством",
    "clear_cache": "Очистить кэш",
    "exit": "Выход",
    "terminal": "Терминал",
    "program": "Программа",
    "material": "Материал",
    "my": "Мое",
    "display_type": "Тип дисплея",
    "proportion": "Пропорция",
    "resolution": "Разрешение",
    "screen_orientation": "Ориентация экрана",
    "landscape": "Горизонтальный",
    "portrait": "Вертикальный",
    "add_resolution": "Добавить разрешение",
    "execute_formatting_when_focus_lost": "Выполнить форматирование при потере фокуса",
    "select_resolution": "Пожалуйста, выберите разрешение",
    "resolution_list": "Список разрешений",
    "confirm_delete_program": "Вы уверены, что хотите удалить программу?",
    "confirm_delete_this_program": "Вы уверены, что хотите удалить эту программу?",
    "bound_tasks_exists_confirm_delete": "Есть связанные задачи, вы уверены, что хотите удалить?",
    "prompt": "Подсказка",
    "delete_failed": "Не удалось удалить",
    "modification_time": "Время изменения",
"resolution_": "Разрешение",
    "associated_tasks": "Связанные задачи",
    "bound_task": "Связанная задача",
    "program_management": "Управление программами",
    "task": "Задача",
    "progress": "Прогресс",
    "phone_number": "Номер телефона",
    "enter_phone_number": "Пожалуйста, введите номер телефона",
    "password": "Пароль",
    "confirm_password": "Подтвердите пароль",
    "enter_password_again": "Пожалуйста, введите пароль еще раз",
    "company_name": "Название компании",
    "enter_company_name": "Пожалуйста, введите название вашей компании",
    "address": "Адрес",
    "enter_address": "Пожалуйста, введите контактный адрес",
    "username_not_exist": "Имя пользователя не существует",
    "enter_new_password": "Пожалуйста, введите новый пароль",
    "enter_new_password_again": "Пожалуйста, введите новый пароль еще раз",
    "terminal_management": "Управление терминалом",
    "delete_group": "Удалить группу",
    "pel_select_group": "Пожалуйста, выберите группу",
    "enter_device_name": "Пожалуйста, введите название устройства",
    "delete_device": "Удалить устройство",
    "confirm_delete_device": "Вы уверены, что хотите удалить это устройство?",
    "terminal_information": "Информация о терминале",
    "qr_code_error": "Ошибка QR-кода",
    "device_not_supported": "Устройство не поддерживается",
    "device_offline": "Выбранное устройство должно быть онлайн для отправки команды, пожалуйста, выберите снова!",
    "more": "Еще",
    "device_access": "Доступ к устройству",
    "filter": "Фильтр",
    "all": "Все",
    "offline": "Офлайн",
    "device_name": "Название устройства",
    "device_number": "Номер устройства",
    "device_group": "Группа устройств",
    "call_device_please_wait": "Вызов устройства, пожалуйста, подождите...",
    "create_terminal_group": "Создать группу устройств",
    "enter_search_keyword": "Пожалуйста, введите ключевое слово для поиска",
    "bind_device": "Привязать устройство",
    "select_device_group": "Пожалуйста, выберите группу устройств",
    "authorized": "Авторизовано",
    "unauthorized": "Не авторизовано",
    "adjust_volume": "Отрегулируйте громкость",
    "reboot_device": "Перезагрузить устройство",
    "wake_up": "Пробуждать",
    "sleep": "Спячка",
    "shutdown": "Выключить",
    "clean_up_timing_on_off": "Время очистки",
    "clean_up_disk": "Очистить диск",
    "clean_up_task": "Очистить задачу",
    "send_command": "Отправить команду",
    "confirm2": "Вы уверены, что хотите отправить -",
    "terminal_operation": "Операция терминала",
    "bind_task": "Информация о задаче",
    "remote_command": "Удаленная команда",
    "remote_monitor": "Удаленный мониторинг",
    "adding_one_will_override_the_previous": "Добавление новой записи перезапишет предыдущую",
    "screenshot_in_progress_please_wait": "Снимок экрана выполняется, пожалуйста, подождите",
    "schedule_on_off": "Расписание включения/выключения",
    "shutdown_time": "Время выключения",
    "startup_time": "Время включения",
    "volume_setting": "Настройка громкости",
    "edit_device_name": "Редактировать название устройства",
    "please_select_time": "Пожалуйста, выберите время",
    "device_not_online_please_retry": "Устройство не в сети, пожалуйста, попробуйте снова",
    "sent_successfully": "Успешно отправлено",
    "version": "V4.1.8",
    "texta": "Текст",
    "userName": "Аккаунт",
    "email": "Электронная почта",
    "device_memory": "Память устройства",
    "device": "Устройство",
    "device_mac": "MAC-адрес устройства",
    "screen_count": "Количество экранов",
    "device_location": "Расположение устройства",
    "is_authorized": "Авторизовано ли",
    "remark": "Примечание",
    "device_ip": "IP-адрес устройства",
    "system_version": "Версия системы",
    "playback_date": "Дата воспроизведения",
    "playback_period": "Период воспроизведения",
    "retrieve_again": "Повторно получить",
    "please_enter_password": "Пожалуйста, введите пароль длиной более 8 символов, содержащий цифры, буквы и специальные символы [@#$%^&+=]!",
    "passwords_do_not_match": "Пароли не совпадают",
    "enter_new_password2": "Введите новый пароль",
    "current_password_too_simple": "Текущий пароль слишком простой. Для защиты вашей учетной записи, пожалуйста, измените пароль на более сложный, содержащий более 8 символов, цифры, буквы и специальные символы [@#$%^&+=]",
    "creation_time": "Время создания",
    "login2": "Войти",
    "welcome": "Добро пожаловать",
    "expired_login": "Срок действия аутентификации истек, пожалуйста, войдите снова.",
    "control": "Удаленное управление",
    "add_task": "Добавить задачу",
    "program_list": "Список программ",
    "terminal_info": "Информация о терминале",
    "add_program": "Добавить программу",
    "material_management": "Управление материалами",
    "change_password": "Изменить пароль",
    "enter_text_content": "Пожалуйста, введите текстовое содержание",
    "hit_the_wall_on_back": "Дальше идти некуда",
    "last_ceremony": "Последняя церемония",
    "already_top_level": "Уже на самом верхнем уровне",
    "already_last_one": "Это уже последний раз",
    "white_fox": "Белая лиса",
    "control_img": "Изображение",
    "control_video": "Видео",
    "control_streaming": "Потоковое видео",
    "control_webPage": "Веб-сайт",
    "control_subtitle": "Текст",
    "control_HDMI": "HDMI",
    "control_addbackground": "Фон",
    "Up": "Загрузить",
    "onlyOne": "Можно добавить только один контроллер",
    "clearBg": "Очистить фон",
    "get_code": "Пожалуйста, сначала введите код подтверждения",
    "del_Null_Program": "Очистить список пустых программ?",
    "please_select_date": "Пожалуйста, выберите хотя бы одну дату",
    "last_size": "Оставшееся пространство",
    "shutdown_tips": "После выключения устройство не может быть включено удаленно",
    "last_size_upload": "Пожалуйста, выберите снова.",
    "end_date_earlier_than_start_date": "Дата окончания не может быть раньше даты начала",
    "account_type": "Тип пользователя",
    "user_type": "Пользователь уровня {level}",
    "customer_type": "Клиент уровня {level}",
    "role_type": "Роль",
    "super_administrator": "Суперадминистратор",
    "term_info_empty": "Информация о терминале пуста",
    "select_terminal_prompt": "Пожалуйста, выберите терминал, нажав кнопку списка в правом верхнем углу",
    "select": "Выбрать",
    "data_empty": "Данные отсутствуют!",
    "content_review": "Проверка содержания",
    "start_date": "Дата начала",
    "end_date": "Дата окончания",
    "start_time": "Время начала",
    "end_time": "Время окончания",
    "select_all": "Выбрать все",
    "select_group": "Выбрать группу",
    "review": "Проверка",
    "material_type": "Тип материала",
    "audio": "Аудио",
    "document": "Документ",
    "material_status": "Статус материала",
    "material_review": "Проверка материала",
    "current_selection_requires_review": "Текущий выбор материала требует проверки?",
    "invCode": "Код приглашения",
    "tip_invitation_empty": "Пожалуйста, введите код приглашения",
    "enter_userName": "Пожалуйста, введите учетную запись пользователя",
    "enter_email": "Пожалуйста, введите электронную почту",
    "file_less_38": "Файл меньше 38 КБ",
    "viewError": "Этот файл не поддерживает просмотр",
    "user": "Личная информация",
    "phone_number_too_short": "Длина номера телефона должна быть больше 9 символов",
    "oneImage": "Фоновое изображение уже существует. Чтобы загрузить новое, сначала удалите старое",
    "del_title": "Подтвердить удаление",
    "del_message": "Вы уверены, что хотите удалить этот контроллер?",
    "close": "Закрыть",
    "exit_group_name": "Редактировать название группы",
    "group_management": "Управление группами",
    "language": "Переключение языка",
    "mixture": "Смешивание",
    "date": "Дата",
    "weeks": "Недели",
    "time": "Час",
    "new_password": "Новый пароль",
    "enter_invCode": "Совет: код приглашения можно получить у вашего старшего администратора",
    "msg_password": "Совет: пожалуйста, введите пароль длиной более 8 символов, содержащий цифры, буквы и специальные символы [@#$%^&+=]",
    "oneDoc": "Документ уже существует. Чтобы загрузить новый, сначала удалите старый",
    "Sunday": "Воскресенье",
    "Monday": "Понедельник",
    "Tuesday": "Вторник",
    "Wednesday": "Среда",
    "Thursday": "Четверг",
    "Friday": "Пятница",
    "Saturday": "Суббота",
    "input_error": "Все поля формы не могут быть пустыми",
    "video_tutorial": "Материалы",
    "view": "Просмотр онлайн",
    "selectDeviceOne": "Для этой команды можно выбрать только одно устройство",
    "select_device_list": "Список выбранных устройств",
    "small_size": "Маленький",
    "medium_size": "Средний",
    "large_size": "Большой",
    "device_info": "Детали устройства",
    "notification": "Уведомление",
    "notif_title": "Содержание уведомления",
    "notif_msg": "С 5 ноября 2024 года Центр обслуживания ETV удалит материалы, хранящиеся более 1 года. Пожалуйста, заранее сделайте резервные копии важных материалов. Спасибо за понимание и сотрудничество.",
    "reduce": "Уменьшить",
    "bound_material": "Связанный материал",
    "tip_material": "Привязанный к программе материал нельзя удалить. Сначала отвяжите материал",
    "boundpo": "Связанная программа",
    "bind_progron": "Этот материал связан с программой и не может быть удален",
    "index": "Индекс",
    "source": "Источник",
    "getUploadSet_tip": "Не удалось получить настройки загрузки материала",
    "getUploadstartTime_tip": "Текущее время запрещает загрузку материала. Пожалуйста, загружайте в разрешенное время",
    "getUploadendTim": "Запрещено загружать материал",
    "download": "Скачать",
    "network_import": "Сетевой импорт",
    "mobile_mode": "Мобильный режим",
    "standalone_mode": "Автономный режим",
    "network_connection": "1. Сетевое подключение",
    "network_methods": "Существуют два способа сетевого подключения:",
    "network_method_1": "(1) Настройки → Сеть и Интернет → WLAN → Подключиться к сети → После подключения к сети откройте ETV → Значок сети станет белым, что означает успешное подключение.",
    "network_method_2": "(2) Откройте ETV → Щелкните правой кнопкой мыши → Настройки программного обеспечения → Выберите сетевой импорт, нажмите далее → Настройки свойств → Настройки WiFi → Перейдите к экрану подключения WiFi, подключитесь к сети → Вернитесь на предыдущий экран → Выйдите на главный экран ETV → Значок сети станет белым, что означает успешное подключение.",
    "account_registration": "2. Регистрация аккаунта",
    "registration_methods": "Существуют два способа регистрации:",
    "registration_method_1": "(1) Связаться с вышестоящим для распределения аккаунта: Вышестоящий пользователь входит в аккаунт → Управление клиентами → Добавить клиента → Заполнить информацию о клиенте и нажать подтвердить → Успешное создание, информация об аккаунте отображается в списке клиентов.",
    "registration_method_2": "(2) Свободная регистрация аккаунта: Вход на серверную страницу → Регистрация аккаунта → Заполнить информацию по требованию и нажать отправить → Успешная регистрация.",
    "invitation_code_source": "Источник кода приглашения: Вышестоящий пользователь входит в аккаунт → Настройки системы → Управление кодами приглашения → Добавить код приглашения.",
    "device_connection": "3. Подключение устройства",
    "device_connection_steps": "Откройте ETV → Щелкните правой кнопкой мыши → Настройки программного обеспечения → Выберите сетевой импорт, нажмите далее → Заполните адрес сервера (адрес серверного входа), порт управления (по умолчанию 8899), имя пользователя (распределенное вышестоящим или самостоятельно зарегистрированное) → Нажмите подключить → После успешного подключения устройство отображает статус подключения, а серверный список устройств отображает информацию об устройстве.",
    "connect_terminal": "1. Подключение терминального устройства",
    "scan_qr_code": "1. Сканирование QR-кода в левом верхнем углу: Сканируйте QR-код терминала для подключения устройства.",
    "device_List": "2. Список устройств в правом верхнем углу: Список всех устройств в локальной сети, выберите устройство.",
    "remote_Command": "2. Удаленные команды",
    "send_Command": "Отправка команды на терминальное устройство, которое выполнит соответствующую реакцию",
    "quick_send_program": "3. Быстрая отправка программы",
    "quick_send_steps": "Отправка команды быстрого отображения → Получение локальных изображений, видео, документов, выбор материала для отправки, нажмите подтвердить → Установить время воспроизведения программы, нажмите подтвердить → Успешная отправка программы.",
    "program_creation": "4. Создание программы",
    "new_program": "1. Создание новой программы: Введите название программы длиной не менее двух символов (название будет автоматически сгенерировано по времени создания), выберите ориентацию экрана и тип отображения в зависимости от экрана терминального устройства, после успешного создания перейдите к редактированию программы.",
    "program_editing": "2. Редактирование программы: Выберите режим воспроизведения программы (замена, вставка, добавление), нажмите «<img src='/static/images/help/icon.png' alt='' />», чтобы добавить контроллер (изображение, видео, смешанное воспроизведение, документ и т.д.), можно свободно регулировать размер и положение контроллера, нажмите «<img src='/static/images/help/icon_2.png' alt='' />», чтобы добавить материал, внизу можно настроить различные свойства контроллера.",
    "program_sending": "5. Отправка программы",
    "send_program_steps": "Создайте программу → Нажмите отправить → Появится список устройств, выберите устройство → Нажмите подтвердить → Перейдите к экрану загрузки, отображающему прогресс загрузки → После 100% загрузки отображается завершение → Терминальное устройство воспроизводит отправленную программу.",
    "simple_mode_title": "1. Простой режим (по умолчанию)",
    "simple_mode_description": "Этот режим является стандартным методом импорта в автономном режиме, просто поместите изображения и видео в корневую директорию USB-накопителя и вставьте USB-накопитель в плату для успешного импорта;",
    "simple_mode_note": "(PS: поддерживается только импорт изображений и видео, аналогично плагину для смешанного воспроизведения, для других сценариев используйте второй метод автономного режима)",
    "regular_mode_title": "2. Обычный режим",
    "regular_mode_description": "Выберите «Автономный режим», нажмите далее, чтобы перейти к экрану автономного режима (см. изображение ниже)",
    "regular_mode_steps": "1. Настройка главного экрана: перейдите к настройке главного экрана<br>2. Настройка дополнительного экрана: перейдите к настройке дополнительного экрана",
    "step_one": "Первый шаг:",
    "step_one_description": "Подключите USB-накопитель, создайте в корневой директории папку с именем «etv-media», в папке etv-media создайте папку «main», если нужно отправить задачу на два экрана, создайте папку «double» в папке etv-media",
    "step_two": "Второй шаг:",
    "step_two_description": "В зависимости от выбора главного или дополнительного экрана создайте соответствующие папки 1/2/3/4 в папке main или double",
    "step_three": "Третий шаг:",
    "step_three_description": "Скопируйте соответствующие изображения/видео в папки 1/2/3/4 в папке main или double",
    "step_four": "Четвертый шаг:",
    "step_four_description": "Поддерживается полноэкранное воспроизведение PDF-документов, разрешается только один документ",
    "step_five": "Пятый шаг:",
    "step_five_description": "Аудиофайлы поместите в папку main или double, система автоматически переключается",
    "play_order_title": "Порядок воспроизведения:",
    "play_order_description": "1. В первую очередь воспроизводятся файлы, названные цифрами, в порядке от меньшего к большему<br>2. Затем воспроизводятся файлы, названные буквами, в порядке от A до Z<br>3. В последнюю очередь воспроизводятся файлы, названные китайскими символами, в порядке первых букв каждого символа от A до Z",
    "document_playback_note": "О воспроизведении документов (этот переключатель включен по умолчанию): Переключатель отображения документов на платах 3128 и M11 по умолчанию выключен (для экономии производительности), требуется ручное включение переключателя отображения документов",
      program_review: 'Обзор программы',
      pass: 'Пройти',
      not_passed_or_not_reviewed: 'Не пройдено или не проверено',
      play_mode: 'Режим воспроизведения',
      review_status: 'Статус проверки',
      reject: 'Отклонить',
      review_content: 'Содержание проверки',
      enter_review_content: 'Пожалуйста, введите содержание проверки',
      device_quantity: "Количество устройств",
      noMore: 'Méiyǒu gèng duō le',
      nameLengthLimit: 'Пожалуйста, ограничьте длину имени 50 символами',
      "customer_title": "Запрос учетной записи",
      "authorized_devices": "Авторизованные устройства",
      "enable": "Включить",
      "disable": "Отключить",
      "expired": "Срок действия истек",
      "valid_date": "Срок действия",
      "valid_date_placeholder": "Введите срок действия",
      "capacity_rule": "Емкость сервера должна быть кратна 100",
      "capacity_label": "Емкость сервера (МБ)",
      "download_speed": "Ограничение скорости загрузки",
      "submit_btn": "Отправить",
      "sub_accounts":"Только изменение подчиненных аккаунтов",
      plan_mode: 'Режим планирования',
      default_mode: 'Режим по умолчанию',
      "help": "Справка",
      "network_mode": "Сетевая рассылка",
      "phone_mode": "Режим телефона",
      "apk_download": "Скачать APK",
      "android": "Android",
      "ios": "iOS",
      "app_name": "ETV-H5 Ассистент публикации информации",
      "info_publish": "Публикация информации",
      "upload_material": "Загрузка материалов",
      "wx_config_incomplete": "Параметры конфигурации WeChat неполные",
      "wx_missing_appid": "Отсутствует appId в конфигурации WeChat",
      "wx_jssdk_not_loaded": "WeChat JS-SDK не загружен, обновите страницу и повторите попытку",
      "wx_version_not_support_scan": "Текущая версия WeChat не поддерживает функцию сканирования, обновите WeChat",
      "wx_signature_failed": "Ошибка проверки подписи WeChat, проверьте алгоритм подписи и URL в бэкенде",
      "wx_domain_not_config": "Текущий домен не настроен в WeChat Official Platform, настройте домен безопасности JS-интерфейса",
      "wx_config_failed": "Ошибка конфигурации WeChat",
      "wx_scan_init_failed": "Не удалось инициализировать функцию сканирования WeChat",
      "browser_not_support_camera": "Ваш браузер не поддерживает функцию камеры",
      "scan_content_unrecognized": "Содержимое сканирования не распознано, повторите попытку!",
      "scan_lib_load_failed": "Не удалось загрузить библиотеку сканирования, обновите страницу и повторите попытку",
      "wx_scan_not_ready": "Функция сканирования WeChat не готова, инициализация...",
      "wx_scan_permission_denied": "Разрешение на сканирование WeChat отклонено, проверьте настройки WeChat или обновите страницу",
      "scan_connect": "Сканировать для подключения",
      "confirm_connect_device": "Подтвердить устройство подключения",
      "confirm_connect_device_msg": "Подключиться к {deviceName}?",
      "data_lost_rescan": "Данные утеряны, отсканируйте снова",
      "connect_failed_retry": "Ошибка подключения, повторите попытку",
      "qrcode_placeholder": "Поместите QR-код в рамку",
      "camera_unauthorized": "Доступ к камере не авторизован",
      "camera_not_found": "Устройство камеры не найдено",
      "camera_select_failed": "Не удалось выбрать устройство камеры",
      "camera_start_failed": "Не удалось запустить камеру, нажмите для повторной попытки",
      "camera_permission_requesting": "Запрос разрешения на доступ к камере",
      "camera_click_to_start": "Нажмите на экран, чтобы запустить камеру",
      "camera_permission_denied": "Разрешите доступ к камере, нажмите для повторной попытки",
      "camera_device_not_found": "Устройство камеры не найдено",
      "camera_init_failed": "Ошибка инициализации камеры, нажмите для повторной попытки",
      "scanner_not_initialized": "Сканер QR-кодов не инициализирован",
      "scan_start_failed": "Не удалось начать сканирование QR-кода",
      "qrcode_format_error": "Неверный формат данных QR-кода",
      "qrcode_verify_success": "Проверка QR-кода прошла успешно",
      "qrcode_verify_failed": "Ошибка проверки QR-кода",
      "process_failed": "Ошибка обработки",
      "camera_not_found_current": "Не удалось найти текущую камеру",
      "camera_switch_failed": "Не удалось переключиться на другую камеру",
      "camera_no_alternatives": "Альтернативные камеры не обнаружены",
      "scan_QR_code": "Сканировать",
      "img_size": "Аномалия пикселей изображения, проверьте и загрузите.",
      "file_size_exceed_skip":'Размер файла не должен превышать',
      "processing": "Обработка",
      "failed": "Сбой",
      "no_menu_permissions_contact_admin": "Нет прав на меню, обратитесь к администратору",
      "superior_name": "Имя Руководителя",
},
  vanDialog: {
    confirm: 'Уверенный',
    cancel: 'отменять'
  },
    vanPicker: {
        confirm: 'Подтвердить',
        cancel: 'Отмена',
    },
    vanDatetimePicker: {
        title: 'Выберите дату',
    },
}